import * as React from 'react';
import { Layer } from 'react-map-gl';

import { ILoaderProps } from '../../../layer/ILoaderProps';
import { LoadableSource } from '../../../layer/LoadableSource';
import { Config } from '../../../../Config';

const LandUse = (props: ILoaderProps) => 
  <LoadableSource path="https://apigeostore.longline.co.uk/dataset/119fda8b1326a7d8a51761bc3d1ccd12dd4dda4c" {...props}>
    <Layer
      id='land_use'
      beforeId={Config.UI.before_layer}
      type='fill'
      layout={{ visibility: props.active ? "visible" : "none" }}          
      paint={{ 
        'fill-opacity': [
          'case',
          ['boolean', ['feature-state', 'hover'], false],
          1.00,
          0.60
        ],
        "fill-color": [
          'case',
          ['==', ['get', 'landuse'], "Combined urban area"], "#E31A1C",
          ['==', ['get', 'landuse'], "Urban area"], "#FF7F00",
          ['==', ['get', 'landuse'], "Arable land"], "#F4F141",
          ['==', ['get', 'landuse'], "Pasture"], "#3CCF14",
          ['==', ['get', 'landuse'], "Forest"], "#317F5C",
          ['==', ['get', 'landuse'], "Range-grass"], "#ABABAB",
          ['==', ['get', 'landuse'], "Range-brush"], "#D37C66",
          ['==', ['get', 'landuse'], "Water"], "#3D3AE4",
          "black"
          ]
      }}
    />
    <Layer
      beforeId={Config.UI.before_layer}
      type='line'
      layout={{ visibility: props.active ? "visible" : "none" }}          
      paint={{
        "line-color": "white",
        'line-width': [
          'case',
          ['boolean', ['feature-state', 'hover'], false],
          2,
          0
          ]
      }}
    />   
  </LoadableSource>

export { LandUse } 
